import RootState from 'typings/RootState'
import { Event } from '../../types/event'
import { DataList, DataDetail } from './types'

export const selectEvent = (state: RootState): Event =>
  state.adminReportCommission.Event

export const selectReportList = (state: RootState): DataList =>
  state.adminReportCommission.DataList

export const selectReportDetail = (state: RootState): DataDetail =>
  state.adminReportCommission.DataDetail

export const selectFilter = (state: RootState) =>
  state.adminReportCommission.Filter
